import React, { useMemo } from "react";
import PropTypes from "prop-types";
import AnalyzerTable from "../components/AnalyzerTable_v2";

export const TableComponent = (props) => {
	const { data, grouping, title, showTitle = true, measures, endpoint, tableType, showIcons = false, showTotalRow = false, onRowClick } = props;

	// AnalyzerTable expects sourceData as an object with data and grouping properties
	// Memoize to prevent recreating the object on every render
	const sourceData = useMemo(() => ({
		data: data || [],
		grouping: grouping
	}), [data, grouping]);

	// Check if this is a resource changes table
	const isResourceChangesTable = endpoint === "/get-resource-changes" || tableType === "resource-changes";
	
	// Hide title when there's no data and it's a resource changes table
	const hasData = data && data.length > 0;
	const shouldShowTitle = title && showTitle && (!isResourceChangesTable || hasData);

	return (
		<div className="w-full flex flex-col">
			<div className="bg-card rounded-card border border-card-bd p-4 flex flex-col relative">
				{shouldShowTitle && (
					<div className=" top-2 left-2 z-10 p-2 pointer-events-none">
						<div className="text-text text-lg font-semibold widget-title" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
				{title}
						</div>
					</div>
				)}
				<div className={`flex flex-col ${shouldShowTitle ? 'pt-2' : ''}`}>
					<AnalyzerTable 
						sourceData={sourceData}
						grouping={grouping}
						measures={measures}
						endpoint={endpoint}
						tableType={tableType}
						showIcons={showIcons}
						showTotalRow={showTotalRow}
						onRowClick={onRowClick}
					/>
				</div>
			</div>
		</div>
	);
};

TableComponent.propTypes = {
	data: PropTypes.array,
	grouping: PropTypes.string,
	title: PropTypes.string,
	valueName: PropTypes.string,
	showTitle: PropTypes.bool,
	measures: PropTypes.arrayOf(PropTypes.string),
	endpoint: PropTypes.string,
	tableType: PropTypes.string,
	showIcons: PropTypes.bool,
	showTotalRow: PropTypes.bool,
	onRowClick: PropTypes.func
};
